@if (shouldShow$ | async) {
  <div class="fullscreen-overlay">
    <form
      #form
      [action]="paymentUrl"
      method="post"
      ngNoForm>
      <div class="subscription-wrapper px-3 px-lg-4">
        <app-subscription-packages
          [currentPackage]="currentPackage"
          (packageChange)="onSelectPackage($event)"
          (frequencyChange)="onFrequencyChange($event)">
          <ng-container content>
            <div class="text-end">
              <button
                type="button"
                class="btn btn-primary"
                (click)="requestSubscriptionPaymentDetails()"
                [disabled]="paymentRequested()">
                {{ paymentRequested() ? 'Redirecting...' : 'Proceed to payment' }}
                @if (paymentRequested()) {
                  <div class="ms-3 spinner-border spinner-border-sm">
                    <span class="visually-hidden">Redirecting...</span>
                  </div>
                }
              </button>
            </div>
          </ng-container>
        </app-subscription-packages>
      </div>

      @for (field of formFields; track field.name) {
        <input
          [name]="field.name"
          type="hidden"
          [value]="field.value" />
      }
    </form>
  </div>
}
